// extracted by mini-css-extract-plugin
module.exports = {"intro":"Newspaper-module--intro--2SAIG","pages":"Newspaper-module--pages--bh7Ad"};